import React from 'react';
import { BoneIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-blue-950 px-4 py-6 text-center md:px-12 md:py-8" data-id="element-57" data-mp="83vwxc2bzm21">
      <h2 className="text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-amber-400 md:text-[29px]" data-id="element-58" data-mp="m3x04y62j5ko">
        One last question
      </h2>
      <p className="mx-auto mt-2 max-w-[580px] text-[16px] font-bold leading-[1.35] text-white md:text-[19px]" data-id="element-59" data-mp="vui5d4g8z8ck">
        How often do you need to consult different resources to organize rehabilitation for a patient after knee surgery?
      </p>
      <p className="mx-auto mt-2 max-w-[580px] text-[14px] leading-[1.45] text-blue-200 md:text-[15px]" data-id="element-60" data-mp="14w7xydlv8dbx">
        Keep working with separate materials for every procedure — or bring them together in one collection organized by
        surgery.
      </p>
      <p className="mt-2 text-[13px] font-extrabold uppercase text-amber-400 md:text-[14px]" data-id="element-61" data-mp="2h3rce606ut8w">
        Identify. Assess. Select. Rehabilitate. Reassess.
      </p>

      <div className="mx-auto mt-3 max-w-[240px]" data-id="element-62" data-mp="2m1j5h3ckkleo">
        <ProductImage data-id="element-63" data-mp="2r2gpllh53pit" />
      </div>

      <h3 className="mx-auto mt-2 max-w-[600px] text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-white md:text-[28px]" data-id="element-64" data-mp="2r3ibym3lvyfu">
        <BoneIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-teal-300" strokeWidth={2.5} aria-hidden data-id="element-65" data-mp="302c3vz5zs0n2" />
        Complete Postoperative Knee Rehabilitation System™
      </h3>
      <p className="mx-auto mt-1 max-w-[600px] text-[11px] font-bold uppercase leading-tight text-white md:text-[12px]" data-id="element-66" data-mp="34vogfaxecgzg">
        The complete postoperative knee rehabilitation collection for physical therapy professionals
      </p>
      <p className="mt-1.5 text-[13px] font-extrabold uppercase text-teal-300 md:text-[14px]" data-id="element-67" data-mp="3isld3t074so9">
        7 Advanced Volumes + 5 FREE Professional Bonuses
      </p>
      <p className="mt-3 text-[13px] font-extrabold uppercase leading-tight text-white md:text-[14px]" data-id="element-68" data-mp="1jlz5abqkvzs5">
        Get the complete collection today for only
      </p>
      <p className="mt-1 text-[42px] font-extrabold leading-none tracking-[-1px] text-amber-400 md:text-[50px]" data-id="element-69" data-mp="1shgjn9il4j29">
        {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-white md:text-[20px]" data-id="element-70" data-mp="22eunm9nbnfdo">USD</span>
      </p>
      <div className="mt-3" data-id="element-71" data-mp="1xfqgdojyjrpz">
        <CtaButton mode="checkout" data-id="element-72" data-mp="1xgjey28rjax1">Get instant access</CtaButton>
      </div>
      <p className="mt-2 text-[12px] font-semibold text-blue-200 md:text-[13px]" data-id="element-73" data-mp="2bfj5jffu5zvu">
        Instant Digital Access{guaranteeEnabled && ' • 7-Day Money-Back Guarantee'}
      </p>
      <p className="mx-auto mt-1.5 max-w-[440px] text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-74" data-mp="27bte8i7s1474">
        {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-300" aria-hidden data-id="element-75" data-mp="d0y9xs3mkba5" />}
        7 volumes + 5 FREE professional bonuses
      </p>
    </section>;
}